{
  "loading": "正在加载...",
  "error": "错误",
  "cancel": "取消",
  "confirm": "确认",
  "close": "关闭",
  "open": "开启",
  "ok": "确定",
  "yes": "是",
  "no": "否",
  "continue": "继续",
  "back": "返回",
  "next": "下一步",
  "finish": "完成",
  "save": "保存",
  "delete": "删除",
  "edit": "编辑",
  "create": "创建",
  "update": "更新",
  "refresh": "刷新",
  "success": "成功",
  "warning": "警告",
  "info": "信息",
  "search-placeholder": "搜索...",
  "message-input": "输入您的消息...",
  "please-log-in-to-access-this-page": "请登录以访问此页面",
  "go-to-settings": "前往设置",
  "go-back": "返回",
  "welcome-user": "欢迎，{$username}！",
  "notification-count": "{$count ->\n   [0] 无通知\n   *[other] {$count} 则通知\n  }",
  "user-offline": "用户离线",
  "user-offline-message": "{$source ->\n   [streamer] 看起来 <1>@{$handle} 离线</1>了，但他们推荐观看：\n   *[default] 看起来 <1>@{$handle} 离线</1>了，但我们推荐观看：\n  }",
  "user-offline-no-recommendations": "看起来 <1>@{$handle} 离线</1>了。\n请稍后再来看看。",
  "streaming-title": "正在直播 {$title}",
  "viewer-count": "{$count} 位观众",
  "pds-selector-title": "刚接触 Atmosphere 吗？",
  "pds-selector-description": "您需要选择一个 PDS (个人数据服务器) 来访问 Atmosphere 上的应用程序，例如 Bluesky、Tangled 和 Spark。",
  "pds-selector-custom-label": "另一个 PDS",
  "pds-selector-custom-description": "请输入您自己的 PDS 主机网址",
  "pds-selector-custom-url-label": "自定义 PDS 网址",
  "pds-selector-custom-url-placeholder": "https://pds.example.com",
  "pds-selector-learn-more": "了解有关自组主机的更多信息",
  "pds-selector-info": "每个主机都有自己的政策和可靠性标准。您的 ATProto 数据存储在您选择的主机上，您可以以后进行迁移。注意：Streamplace 有自己的审核规则——无论您选择哪个主机，都可能会被 Streamplace 禁止使用。",
  "pds-selector-read-policies": "在继续之前，请阅读 {$label} 的<tosLink>服务条款</tosLink>和<privacyLink>隐私政策</privacyLink>。",
  "pds-selector-handle-policy-checkbox": "我已阅读并同意<policyLink>处理政策</policyLink>",
  "login-show-live-on-bluesky": "在 Bluesky 上显示我的直播状态",
  "login-show-live-on-bluesky-description": "直播时为您的 Bluesky 头像加上红色 LIVE 圆环，并允许 Streamplace 代您发布直播公告。取消勾选即可在不授予任何 Bluesky 账号访问权限的情况下登录。"
}
